// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eBzl","comment":"styles_comment__1QAC3"};